<div id="race-hero-vid" *ngIf="emotionalVideoIndex > -1">
  <video id="race-video" [muted]="'muted'" controls autoplay loop preload="metadata"  playsinline webkit-playsinline class="emotional-video" [poster]="videoAssetsInfo[emotionalVideoIndex].thumbnail_url">
  <source [src]="videoAssetsInfo[emotionalVideoIndex].url" type="video/mp4"  />
  </video>
</div>
